<template>
    <div class="collect-h">
        <template class="table-head">
            <el-table :data="collectLists" border height="500" ref="dragTable" v-loading = "isLoading" :default-sort = "{prop: 'applyTime', order: 'descending'}">
                <el-table-column sortable show-overflow-tooltip :prop="item.prop" :label="item.label" v-for="(item, index) in tableDataCollects" :key="index" align="center">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="200" align="center">
                    <template slot-scope="scope">
                         <form id="cellCommit" :action="config.mideaPay" method="post">
                            <input type="hidden" :name="key" :value="val" v-for="(val,key) of payResult" :key="key">
                            <input v-if="scope.row.payType === DEPOSITPAYTYPE.PAYMENT_OF_BEAUTY &&
                         scope.row.approveStatus === AUDIT_STATUS.TO_BE_AUDITED" type="button" id="subText" class="submission" @click="handleClick(scope.row)" value="支 付">

                        <el-button v-if="scope.row.payTypeText === PAYMENT_METHOD.MIDPAY &&
                            scope.row.approveStatus === AUDIT_STATUS.TO_BE_AUDITED"
                            @click="cancelPayment(scope.row)" type="text" size="small">取消支付</el-button>
                        </form>
                        <el-button v-if="scope.row.approveStatus == AUDIT_STATUS.TO_BE_SUBMITTED" @click="submitted(scope.row)" type="text" size="small">提交</el-button>
                        <el-button v-if="scope.row.payTypeText == PAYMENT_METHOD.OFFLINE_PAYMENT || scope.row.fileFalg" @click="lookClick(scope.row)" type="text" size="small">查看附件</el-button>
                        <el-button v-if="scope.row.isElectronicSign == '1' && scope.row.esignature == ESIGN_STATUS.TO_BE_ESIGN && scope.row.approveStatus != AUDIT_STATUS.TO_BE_VOIDED"
                        @click="electronicRevoke(scope.row)" type="text" size="small">电子签章撤回</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </template>

        <Picture v-if="diaShaow" :data="rowData" :imgUrl="imgUrl" :diaShaow="diaShaow" @handleStartClose="handleStartClose"></Picture>
    </div>
</template>

<script>
import data from '../data.js';
// eslint-disable-next-line no-unused-vars
import { DEPOSITPAYTYPE, TIMER } from '../../../../utils/configuration';
import { getPaymentOfBeauty, getAttachment, getCancelPay, applyLetterElectronicRevoke, payApplySubmit } from '../../../../api/depositDetails';
// eslint-disable-next-line no-irregular-whitespace
import config from '@/config/user.env.js';
import Picture from '../dialog/LookPicture';
export default {
    inject: ['loadCellect'],
    components: { Picture },
    props: {
        dataLis: {
            type: Object
        },
        collectLists: {
            type: Array
        }
    },
    data() {
        return {
            config,
            payResult: {},
            rowData: {},
            imgUrl: '',
            isLoading: false,
            diaShaow: false,
            data,
            tableDataCollects: [],
            DEPOSITPAYTYPE: {
                PAYMENT_OF_BEAUTY: '2'
            },
            AUDIT_STATUS: {
                TO_BE_AUDITED: '20', // 待审核
                TO_BE_SUBMITTED: '10', // 待提交
                TO_BE_VOIDED: '99' // 已作废
            },
            ESIGN_STATUS: {
                TO_BE_ESIGN: '0', // 待签章
                TO_BE_ESIGNED: '1' // 已签章
            },
            PAYMENT_METHOD: {
                OFFLINE_PAYMENT: '线下打款',
                MIDPAY: '美的付'
            }
        };
    },
    methods: {
        submitted(row) {
            if (!row.esignature || (row.esignature === this.ESIGN_STATUS.TO_BE_ESIGN)) {
                this.$message.warning('电子签章完成后再提交支付申请');
                return;
            }
            const params = {
                zfJobId: row.jobId
            };
            payApplySubmit(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success(` ${row.applyNo} 单 提交成功`);
                    this.loadCellect();
                }
            });
        },
        electronicRevoke(row) {
            const params = {
                applyBatchNo: row.applyBatchNo
            };
            applyLetterElectronicRevoke(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('已将同一批次的押金缴款明细都撤回');
                    this.loadCellect();
                }
            });
        },
        async handleClick(row) {
            const params = { payAmount: row.cashPaymentAmt,
                applyNo: row.applyNo,
                supCashNo: this.$route.query.supCashNo,
                accountEntity: this.dataLis.ledgerId,
                companyName: this.dataLis.companyName,
                supName: this.dataLis.supName };
            await getPaymentOfBeauty(params).then(res => {
                const paramsData = JSON.parse(res.data);
                if (res && res.code === '0') {
                    this.payResult = paramsData;
                    setTimeout(() => {
                        document.getElementById('cellCommit').submit();
                    }, TIMER.THREE_HUNDRED);
                }
            }).catch(() => {});
        },
        lookClick(row) {
            let subnum1 = {};
            let jobId = {};
            if (row.fileFalg) {
                jobId = { jobId: row.fileFalg };
            } else {
                subnum1 = { subnum1: row.jobId };
            }
            getAttachment({ businessId: this.dataLis.dataJobId, ...jobId, ...subnum1 }).then(res => {
                if (res && res.code === '0') {
                    if (res.data.list.length === 0) {
                        return this.$message.warning(`${row.applyNo} 单号暂无上传附件`);
                    } else {
                        this.imgUrl = res.msg + `?id=${res.data.list[0].attachmentId}`;
                        row.fileFalg && window.open(this.imgUrl, '_blank');
                    }
                }
                this.$nextTick(() => {
                    this.diaShaow = !row.fileFalg;
                });
            }).catch(() => {});
        },
        handleStartClose(data) { this.diaShaow = false; },
        cancelPayment(row) {
            getCancelPay({ jobId: row.jobId }).then(res => {
                if (res && res.code === '0') {
                    this.$message.success(` ${row.applyNo} 单 取消支付成功`);
                    this.loadCellect();
                }
            }).catch(() => {});
        }
    },
    created() {
        this.tableDataCollects = data.tableDataCollects;
    },
    mounted() {},
    watch: {
        // 'dataLis': {
        //     deep: true,
        //     handler: function(newVal, oldVal) {
        //         console.log(newVal, oldVal);
        //         this.companyCode = newVal.companyCode ? newVal.companyCode : '';
        //         this.siteCode = newVal.siteCode ? newVal.siteCode : '';
        //         this.supCode = newVal.supCode ? newVal.supCode : '';
        //         newVal && this.load();
        //     }
        // }
    }
};
</script>

<style lang="less">
.collect-h{
    .submission {
        border-color: transparent;
        color: #00BCBF;
        background: transparent;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        padding: 7px 15px;
        font-size: 12px;
        border:none;
    }
}
</style>
